import styled from 'styled-components';

export const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #e7e7ea;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  max-width: 504px;
  padding: 24px;
  flex-direction: column;
  gap: 32px;
  background-color: #ffffff;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const Title = styled.p`
  font-family: EYInterstate;
  font-size: 20px;
  color: #2e2e38;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const Text = styled.p`
  font-family: EYInterstate;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  margin-top: 0px;
  margin-bottom: 0px;
`;
